import GoogleAnchor from './GoogleAnchor';

export default GoogleAnchor;
